import {ID} from '../config';

export function data() {
	return app.data[ID];
}
